import { render, staticRenderFns } from "./general-quality-result.vue?vue&type=template&id=48c9ca91&scoped=true&"
import script from "./general-quality-result.vue?vue&type=script&lang=js&"
export * from "./general-quality-result.vue?vue&type=script&lang=js&"
import style0 from "./general-quality-result.vue?vue&type=style&index=0&id=48c9ca91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c9ca91",
  null
  
)

export default component.exports